import React, { useState, useRef } from 'react';
import ProduktSklepList from '../../components/Produkt/ProduktSklepList.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import ErrorWindow from '../../components/ErrorWindow/ErrorWindow.js';
import { render } from 'react-dom';
import { getProducentStorage } from './../../dao/DAO.js';
import './KatalogSklepy.css';
const DAO_SKLEP_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/sklepy';
const DAO_PRODUCENT_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/producent';
export default class KatalogSklepy extends React.Component {

        constructor(props) {
                super(props);
                this.state = { produktySklep: [], widoczny: false };
        }

        componentDidMount() {
                if (this.state.widoczny === true) {
                        return;
                }
                const str = RetStr();
                console.log("szukaj RetStr: " + str);
                if (str.length > 0) {
                        axios(DAO_SKLEP_URL, {
                                method: 'POST',
                                withCredentials: false,
                                headers: {
                                        'Accept': 'application/json'
                                },
                                data: { operacja: "produkty_szukaj", str: str }
                        }).then((response) => {
                                console.log("sss:" + JSON.stringify(response.data));
                                this.setState({
                                        produktySklep: response.data.lista,
                                });
                        }).catch(err => console.log(err.message));
                } else {
                        axios(DAO_SKLEP_URL, {
                                method: 'POST',
                                withCredentials: false,
                                headers: {
                                        'Accept': 'application/json'
                                },
                                data: { operacja: "produkty" }
                        }).then((response) => {
                                console.log("sss:" + JSON.stringify(response.data));
                                this.setState({
                                        produktySklep: response.data.lista,
                                });
                        }).catch(err => console.log(err.message));
                }
        }

        render() {
                let biRefErrorWindow = {
                };
                let brefDodaj = {
                        dodajfu: dodajFu,
                        biRefErrorWindow: biRefErrorWindow,
                        st: this
                };
                let list;
                if (this.state.produktySklep.length===0) {
                                return (<>Brak produktów</>);
                } else {
                        list = this.state.produktySklep.map((item, key) => {
                                return (<ProduktSklepList bref={brefDodaj} key={item.id} produkt={item} />);
                        });
                }
                return (
                        <>
                                <Table className="tabela-table" striped bordered hover size="sm">
                                        <tbody>
                                                {list}
                                        </tbody>
                                </Table>
                                <DodajInfo athis={this} err={brefDodaj.biRefErrorWindow} />
                                <ErrorWindow biRef={biRefErrorWindow} />
                        </>

                );
        }
}
function RetStr() {
        const urlElements = window.location.pathname.split('/')
        if (urlElements.length === 5) {
                console.log("RetStr:" + window.location.pathname + " ele:" + urlElements[4]);
                return decodeURI(urlElements[4]);
        }
        return "";
}
function dodajFu(dane, aprodukt) {

        const spr = async () => {
                let pr = getProducentStorage();

                if (pr === null) {
                        window.location = process.env.PUBLIC_URL + "/start";
                }
                aprodukt.nip = pr.nip;
                const res = await axios(DAO_PRODUCENT_URL, {
                        method: 'POST',
                        withCredentials: false,
                        headers: {
                                'Accept': 'application/json'
                        },
                        data: { operacja: "produkt_sprawdz", produkt: aprodukt }
                }).then((response) => {
                        console.log("sss:" + JSON.stringify(response.data));
                        if (typeof (response.data.error) != 'undefined') {
                                console.log("show errorsss" + JSON.stringify(response.data.error));
                                dane.bref.biRefErrorWindow.pokazOkno(response.data.error.info);
                                return null;
                        }
                        console.log("dodaj produkt.nazwas122k:" + JSON.stringify(response.data.produkt));
                        console.log("dodaj produkt.prducent122k:" + JSON.stringify(response.data.producent));
                        return response.data;
                }).catch(err => console.log(err.message));
                if (res === null) {
                        return;
                }
                dane.bref.st.setState({ produkt_prod: res.producent });
                dane.bref.st.setState({ produkt: res.produkt });
                dane.bref.st.setState({ widoczny: true });
        }
        spr();
}
function DodajInfo(prop) {
        const nazwa = useRef(null);
        const marka = useRef(null);
        const ean = useRef(null);
        const nr_katalogowy = useRef(null);
        const opis_krotki = useRef(null);
        const pr_nazwa = useRef(null);
        const pr_nip = useRef(null);
        const pr_www = useRef(null);
        console.log("DodajInfo prop.dane.produkt:" + JSON.stringify(prop.athis.state.produkt));
        console.log("prop.widocznsssy" + prop.athis.state.widoczny);
        const ZamknijSubmit = async e => {
                prop.athis.setState({ widoczny: false });
        }
        const handleSubmitDodaj = async e => {
                console.log("dodaje");
                e.preventDefault();
                console.log(nazwa.current.value);
                let produkt_d = {
                        pr_nazwa: pr_nazwa.current.value,
                        pr_nip: pr_nip.current.value,
                        pr_www: pr_www.current.value,
                        nazwa: nazwa.current.value,
                        marka: marka.current.value,
                        ean: ean.current.value,
                        nr_katalogowy: nr_katalogowy.current.value,
                        opis_krotki: opis_krotki.current.value
                };
                //prop.athis.setState({ widoczny: false });
                console.log("dodaje dane produktu" + JSON.stringify({ operacja: "dodaj_produkt", produkt: produkt_d }));
                const spr = async () => {
                        let pr = getProducentStorage();

                        if (pr === null) {
                                window.location = process.env.PUBLIC_URL + "/start";
                        }
                        const res = await axios(DAO_PRODUCENT_URL, {
                                method: 'POST',
                                withCredentials: false,
                                headers: {
                                        'Accept': 'application/json'
                                },
                                data: { operacja: "dodaj_produkt", produkt: produkt_d }
                        }).then((response) => {
                                console.log("sss:" + JSON.stringify(response.data));
                                if (typeof (response.data.error) != 'undefined') {
                                        console.log("show errorssss33" + JSON.stringify(response.data.error));
                                        prop.err.pokazOkno(response.data.error.info);
                                        return null;
                                }
                                console.log("dodaj produkt.nazwas122k:" + JSON.stringify(response.data));
                                console.log("dodaj produkt.prducent122k:" + JSON.stringify(response.data));
                                return response.data;
                        }).catch(err => console.log(err.message));
                        if (res === null) {
                                return;
                        }
                        console.log("window.location=/produkt/" + res.id_produkt);
                        window.location = process.env.PUBLIC_URL + "/produktpododniu/" + res.id_produkt + "/" + pr_nip.current.value;
                }
                spr();

        }
        if (prop.athis.state.produkt) {
                console.log("prop.athis.state.produkt_prod.nip+" + prop.athis.state.produkt_prod);
                return (
                        <Modal
                                show={prop.athis.state.widoczny}
                                backdrop="static"
                                keyboard={true}
                                className="obramowanie-produkt"
                                size="xl"
                                centered
                                onHide={ZamknijSubmit}
                        >
                                <Modal.Header className="tytul-produkt" closeButton>
                                        <Modal.Title>Dodaj produkt</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                        <Form className="katalog-formularz">
                                                <p className="producent-p m-0">Producent</p>
                                                <hr className="mt-2 mb-2" />
                                                <Form.Group controlId="formBasicEmail">
                                                        <Form.Row>
                                                                <Form.Label column sm="2">Producent</Form.Label>
                                                                <Col sm="10">
                                                                        <Form.Control autoComplete="off" ref={pr_nazwa} className="mt-1 katalog-control" defaultValue={prop.athis.state.produkt_prod.nazwa} size="sm" type="text" placeholder="Wprowadź nazwę producenta..." />
                                                                </Col>
                                                        </Form.Row>
                                                </Form.Group>
                                                <Form.Group controlId="formBasicEmail">
                                                        <Form.Row>
                                                                <Form.Label column sm="2">NIP</Form.Label>
                                                                <Col sm="10">
                                                                        <Form.Control autoComplete="off" ref={pr_nip} className="mt-1 katalog-control" defaultValue={prop.athis.state.produkt_prod.nip} size="sm" type="text" placeholder="Wprowadź NIP..." />
                                                                </Col>
                                                        </Form.Row>
                                                </Form.Group>
                                                <Form.Group controlId="formBasicEmail">
                                                        <Form.Row>
                                                                <Form.Label column sm="2">Strona internetowa</Form.Label>
                                                                <Col sm="10">
                                                                        <Form.Control autoComplete="off" ref={pr_www} className="mt-1 katalog-control" defaultValue={prop.athis.state.produkt_prod.www} size="sm" type="text" placeholder="Wprowadź stronę internetową..." />
                                                                </Col>
                                                        </Form.Row>
                                                </Form.Group>
                                                <p className="produkt-p m-0">Produkt</p>
                                                <hr className="mt-2 mb-2" />
                                                <Form.Group controlId="formBasicEmail">
                                                        <Form.Row>
                                                                <Form.Label column sm="2">Nazwa produktu</Form.Label>
                                                                <Col sm="10">
                                                                        <Form.Control autoComplete="off" ref={nazwa} className="mt-1 katalog-control" defaultValue={prop.athis.state.produkt.nazwa} size="sm" type="text" placeholder="Wprowadź nazwę produktu..." />
                                                                </Col>
                                                        </Form.Row>
                                                </Form.Group>
                                                <Form.Group controlId="formBasicEmail">
                                                        <Form.Row>
                                                                <Form.Label column sm="2">Marka</Form.Label>
                                                                <Col sm="10">
                                                                        <Form.Control autoComplete="off" ref={marka} className="mt-1 katalog-control" defaultValue={prop.athis.state.produkt.marka} size="sm" type="text" placeholder="Wprowadź markę produktu..." />
                                                                </Col>
                                                        </Form.Row>
                                                </Form.Group>
                                                <Form.Group controlId="formBasicEmail">
                                                        <Form.Row>
                                                                <Form.Label column sm="2">Kod EAN<a target="_blank" href={"https://www.eprodukty.gs1.pl/catalog/0"+prop.athis.state.produkt.ean}>GS1</a></Form.Label>
                                                                <Col sm="10">
                                                                        <Form.Control autoComplete="off" ref={ean} className="mt-1 katalog-control" defaultValue={prop.athis.state.produkt.ean} size="sm" type="text" placeholder="Wprowadź kod EAN produktu..." />
                                                                </Col>
                                                        </Form.Row>
                                                </Form.Group>
                                                <Form.Group controlId="formBasicEmail">
                                                        <Form.Row>
                                                                <Form.Label column sm="2">Numer katalogowy</Form.Label>
                                                                <Col sm="10">
                                                                        <Form.Control autoComplete="off" ref={nr_katalogowy} className="mt-1 katalog-control" defaultValue={prop.athis.state.produkt.nr_katalogowy} size="sm" type="text" placeholder="Wprowadź numer katalogowy..." />
                                                                </Col>
                                                        </Form.Row>
                                                </Form.Group>
                                                <Form.Group controlId="opis">
                                                        <Form.Row>
                                                                <Form.Label column sm="2">Opis</Form.Label>
                                                                <Col sm="10">
                                                                        <Form.Control className="mt-1 katalog-control" size="sm" ref={opis_krotki} as="textarea" defaultValue={prop.athis.state.produkt.opis} rows={3} />
                                                                </Col>
                                                        </Form.Row>
                                                </Form.Group>
                                        </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                        <Button variant="success" onClick={handleSubmitDodaj}>Dodaj</Button>
                                        <Button variant="danger" onClick={ZamknijSubmit}>Zamknij</Button>
                                </Modal.Footer>
                        </Modal>);
        } else {
                return (<></>);
        }
}
